import { ResponsiveScatterPlot } from "@nivo/scatterplot";

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
/* const data = [
  {
    id: "group A",
    data: [
      {
        x: 71,
        y: 90,
      },
      {
        x: 34,
        y: 36,
      },
      {
        x: 80,
        y: 74,
      },
      {
        x: 31,
        y: 51,
      },
      {
        x: 0,
        y: 85,
      },
      {
        x: 61,
        y: 120,
      },
      {
        x: 85,
        y: 8,
      },
      {
        x: 87,
        y: 55,
      },
      {
        x: 68,
        y: 26,
      },
      {
        x: 96,
        y: 68,
      },
      {
        x: 38,
        y: 46,
      },
      {
        x: 36,
        y: 65,
      },
      {
        x: 37,
        y: 68,
      },
      {
        x: 66,
        y: 6,
      },
      {
        x: 66,
        y: 55,
      },
      {
        x: 51,
        y: 8,
      },
      {
        x: 56,
        y: 90,
      },
      {
        x: 86,
        y: 74,
      },
      {
        x: 77,
        y: 71,
      },
      {
        x: 94,
        y: 26,
      },
      {
        x: 45,
        y: 104,
      },
      {
        x: 48,
        y: 54,
      },
      {
        x: 76,
        y: 50,
      },
      {
        x: 79,
        y: 110,
      },
      {
        x: 37,
        y: 34,
      },
      {
        x: 87,
        y: 102,
      },
      {
        x: 2,
        y: 36,
      },
      {
        x: 45,
        y: 105,
      },
      {
        x: 24,
        y: 98,
      },
      {
        x: 63,
        y: 47,
      },
      {
        x: 40,
        y: 58,
      },
      {
        x: 43,
        y: 88,
      },
      {
        x: 50,
        y: 119,
      },
      {
        x: 16,
        y: 113,
      },
      {
        x: 3,
        y: 3,
      },
      {
        x: 12,
        y: 55,
      },
      {
        x: 75,
        y: 21,
      },
      {
        x: 88,
        y: 51,
      },
      {
        x: 85,
        y: 102,
      },
      {
        x: 66,
        y: 8,
      },
      {
        x: 22,
        y: 65,
      },
      {
        x: 42,
        y: 61,
      },
      {
        x: 18,
        y: 94,
      },
      {
        x: 88,
        y: 53,
      },
      {
        x: 1,
        y: 77,
      },
      {
        x: 19,
        y: 44,
      },
      {
        x: 89,
        y: 48,
      },
      {
        x: 4,
        y: 73,
      },
      {
        x: 24,
        y: 55,
      },
      {
        x: 91,
        y: 52,
      },
    ],
  },
  {
    id: "group B",
    data: [
      {
        x: 47,
        y: 7,
      },
      {
        x: 13,
        y: 105,
      },
      {
        x: 21,
        y: 61,
      },
      {
        x: 63,
        y: 46,
      },
      {
        x: 13,
        y: 38,
      },
      {
        x: 82,
        y: 0,
      },
      {
        x: 0,
        y: 49,
      },
      {
        x: 69,
        y: 69,
      },
      {
        x: 69,
        y: 39,
      },
      {
        x: 37,
        y: 27,
      },
      {
        x: 59,
        y: 48,
      },
      {
        x: 90,
        y: 39,
      },
      {
        x: 30,
        y: 50,
      },
      {
        x: 25,
        y: 29,
      },
      {
        x: 88,
        y: 94,
      },
      {
        x: 47,
        y: 65,
      },
      {
        x: 1,
        y: 118,
      },
      {
        x: 74,
        y: 117,
      },
      {
        x: 99,
        y: 99,
      },
      {
        x: 97,
        y: 118,
      },
      {
        x: 24,
        y: 23,
      },
      {
        x: 63,
        y: 31,
      },
      {
        x: 50,
        y: 7,
      },
      {
        x: 50,
        y: 95,
      },
      {
        x: 95,
        y: 25,
      },
      {
        x: 3,
        y: 22,
      },
      {
        x: 81,
        y: 52,
      },
      {
        x: 58,
        y: 78,
      },
      {
        x: 98,
        y: 29,
      },
      {
        x: 2,
        y: 3,
      },
      {
        x: 14,
        y: 75,
      },
      {
        x: 67,
        y: 80,
      },
      {
        x: 84,
        y: 10,
      },
      {
        x: 12,
        y: 77,
      },
      {
        x: 91,
        y: 97,
      },
      {
        x: 17,
        y: 75,
      },
      {
        x: 19,
        y: 38,
      },
      {
        x: 43,
        y: 76,
      },
      {
        x: 24,
        y: 64,
      },
      {
        x: 41,
        y: 30,
      },
      {
        x: 70,
        y: 16,
      },
      {
        x: 4,
        y: 91,
      },
      {
        x: 76,
        y: 115,
      },
      {
        x: 61,
        y: 14,
      },
      {
        x: 92,
        y: 5,
      },
      {
        x: 17,
        y: 88,
      },
      {
        x: 64,
        y: 53,
      },
      {
        x: 60,
        y: 71,
      },
      {
        x: 38,
        y: 67,
      },
      {
        x: 65,
        y: 64,
      },
    ],
  },
  {
    id: "group C",
    data: [
      {
        x: 93,
        y: 109,
      },
      {
        x: 18,
        y: 49,
      },
      {
        x: 73,
        y: 51,
      },
      {
        x: 41,
        y: 78,
      },
      {
        x: 76,
        y: 21,
      },
      {
        x: 19,
        y: 78,
      },
      {
        x: 10,
        y: 88,
      },
      {
        x: 27,
        y: 56,
      },
      {
        x: 63,
        y: 52,
      },
      {
        x: 44,
        y: 1,
      },
      {
        x: 62,
        y: 76,
      },
      {
        x: 85,
        y: 37,
      },
      {
        x: 77,
        y: 58,
      },
      {
        x: 46,
        y: 110,
      },
      {
        x: 9,
        y: 105,
      },
      {
        x: 6,
        y: 28,
      },
      {
        x: 87,
        y: 112,
      },
      {
        x: 80,
        y: 0,
      },
      {
        x: 4,
        y: 106,
      },
      {
        x: 73,
        y: 24,
      },
      {
        x: 46,
        y: 50,
      },
      {
        x: 51,
        y: 11,
      },
      {
        x: 37,
        y: 80,
      },
      {
        x: 82,
        y: 88,
      },
      {
        x: 81,
        y: 26,
      },
      {
        x: 38,
        y: 53,
      },
      {
        x: 86,
        y: 114,
      },
      {
        x: 11,
        y: 37,
      },
      {
        x: 89,
        y: 117,
      },
      {
        x: 73,
        y: 22,
      },
      {
        x: 30,
        y: 32,
      },
      {
        x: 81,
        y: 53,
      },
      {
        x: 21,
        y: 85,
      },
      {
        x: 31,
        y: 34,
      },
      {
        x: 68,
        y: 52,
      },
      {
        x: 49,
        y: 5,
      },
      {
        x: 41,
        y: 72,
      },
      {
        x: 1,
        y: 7,
      },
      {
        x: 21,
        y: 34,
      },
      {
        x: 77,
        y: 109,
      },
      {
        x: 40,
        y: 80,
      },
      {
        x: 30,
        y: 92,
      },
      {
        x: 88,
        y: 116,
      },
      {
        x: 10,
        y: 46,
      },
      {
        x: 82,
        y: 82,
      },
      {
        x: 30,
        y: 77,
      },
      {
        x: 53,
        y: 62,
      },
      {
        x: 11,
        y: 46,
      },
      {
        x: 50,
        y: 8,
      },
      {
        x: 68,
        y: 113,
      },
    ],
  },
  {
    id: "group D",
    data: [
      {
        x: 100,
        y: 85,
      },
      {
        x: 68,
        y: 54,
      },
      {
        x: 72,
        y: 29,
      },
      {
        x: 25,
        y: 43,
      },
      {
        x: 76,
        y: 97,
      },
      {
        x: 48,
        y: 62,
      },
      {
        x: 21,
        y: 85,
      },
      {
        x: 1,
        y: 39,
      },
      {
        x: 70,
        y: 45,
      },
      {
        x: 22,
        y: 56,
      },
      {
        x: 29,
        y: 59,
      },
      {
        x: 33,
        y: 15,
      },
      {
        x: 34,
        y: 98,
      },
      {
        x: 88,
        y: 61,
      },
      {
        x: 87,
        y: 34,
      },
      {
        x: 24,
        y: 29,
      },
      {
        x: 84,
        y: 111,
      },
      {
        x: 37,
        y: 15,
      },
      {
        x: 35,
        y: 111,
      },
      {
        x: 81,
        y: 69,
      },
      {
        x: 31,
        y: 1,
      },
      {
        x: 27,
        y: 63,
      },
      {
        x: 11,
        y: 25,
      },
      {
        x: 40,
        y: 34,
      },
      {
        x: 20,
        y: 84,
      },
      {
        x: 87,
        y: 50,
      },
      {
        x: 82,
        y: 73,
      },
      {
        x: 26,
        y: 21,
      },
      {
        x: 59,
        y: 1,
      },
      {
        x: 8,
        y: 10,
      },
      {
        x: 8,
        y: 41,
      },
      {
        x: 78,
        y: 57,
      },
      {
        x: 75,
        y: 81,
      },
      {
        x: 42,
        y: 55,
      },
      {
        x: 68,
        y: 24,
      },
      {
        x: 99,
        y: 5,
      },
      {
        x: 2,
        y: 26,
      },
      {
        x: 41,
        y: 50,
      },
      {
        x: 60,
        y: 73,
      },
      {
        x: 57,
        y: 0,
      },
      {
        x: 37,
        y: 86,
      },
      {
        x: 60,
        y: 56,
      },
      {
        x: 73,
        y: 118,
      },
      {
        x: 41,
        y: 28,
      },
      {
        x: 97,
        y: 56,
      },
      {
        x: 29,
        y: 77,
      },
      {
        x: 29,
        y: 2,
      },
      {
        x: 20,
        y: 64,
      },
      {
        x: 52,
        y: 89,
      },
      {
        x: 61,
        y: 55,
      },
    ],
  },
  {
    id: "group E",
    data: [
      {
        x: 37,
        y: 64,
      },
      {
        x: 31,
        y: 13,
      },
      {
        x: 93,
        y: 15,
      },
      {
        x: 86,
        y: 92,
      },
      {
        x: 74,
        y: 57,
      },
      {
        x: 75,
        y: 38,
      },
      {
        x: 60,
        y: 50,
      },
      {
        x: 71,
        y: 58,
      },
      {
        x: 7,
        y: 73,
      },
      {
        x: 33,
        y: 24,
      },
      {
        x: 31,
        y: 30,
      },
      {
        x: 65,
        y: 5,
      },
      {
        x: 76,
        y: 10,
      },
      {
        x: 26,
        y: 112,
      },
      {
        x: 42,
        y: 38,
      },
      {
        x: 34,
        y: 4,
      },
      {
        x: 95,
        y: 83,
      },
      {
        x: 33,
        y: 56,
      },
      {
        x: 15,
        y: 26,
      },
      {
        x: 24,
        y: 60,
      },
      {
        x: 57,
        y: 87,
      },
      {
        x: 88,
        y: 11,
      },
      {
        x: 60,
        y: 6,
      },
      {
        x: 33,
        y: 58,
      },
      {
        x: 90,
        y: 29,
      },
      {
        x: 87,
        y: 101,
      },
      {
        x: 83,
        y: 61,
      },
      {
        x: 65,
        y: 106,
      },
      {
        x: 55,
        y: 39,
      },
      {
        x: 31,
        y: 108,
      },
      {
        x: 23,
        y: 31,
      },
      {
        x: 54,
        y: 18,
      },
      {
        x: 89,
        y: 75,
      },
      {
        x: 47,
        y: 92,
      },
      {
        x: 92,
        y: 18,
      },
      {
        x: 52,
        y: 118,
      },
      {
        x: 67,
        y: 92,
      },
      {
        x: 60,
        y: 24,
      },
      {
        x: 71,
        y: 89,
      },
      {
        x: 4,
        y: 95,
      },
      {
        x: 52,
        y: 109,
      },
      {
        x: 62,
        y: 96,
      },
      {
        x: 46,
        y: 41,
      },
      {
        x: 21,
        y: 47,
      },
      {
        x: 83,
        y: 20,
      },
      {
        x: 62,
        y: 68,
      },
      {
        x: 92,
        y: 110,
      },
      {
        x: 27,
        y: 98,
      },
      {
        x: 16,
        y: 37,
      },
      {
        x: 34,
        y: 112,
      },
    ],
  },
]; */
const MyResponsiveScatterPlot = ({ data }: { data: any }) => (
  <div style={{ height: "300px" }}>
    <ResponsiveScatterPlot
      data={data}
      margin={{ top: 60, right: 140, bottom: 70, left: 90 }}
      xScale={{
        type: "linear",
        min: "auto", // Slightly less than minimum data value
        max: "auto", // Slightly more than maximum data value
      }}
      nodeSize={18}
      xFormat=">-.2f"
      yScale={{
        type: "linear",
        min: "auto", // This will automatically adjust to include negative values
        max: "auto",
      }}
      yFormat=">-.2f"
      blendMode="multiply"
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Averages",
        legendPosition: "middle",
        legendOffset: -60,
        truncateTickAt: 0,
        // Add grid lines for better readability
        // grid: true,
      }}
      // Add a reference line at y=0
      markers={[
        {
          axis: "y",
          value: 0,
          lineStyle: { stroke: "#b0b0b0", strokeWidth: 1 },
          legend: "",
        },
        {
          axis: "x",
          value: 0,
          lineStyle: { stroke: "#b0b0b0", strokeWidth: 1 },
          legend: "",
        },
      ]}
      legends={[
        {
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 130,
          translateY: 0,
          itemWidth: 100,
          itemHeight: 12,
          itemsSpacing: 5,
          itemDirection: "left-to-right",
          symbolSize: 12,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  </div>
);

export default MyResponsiveScatterPlot;
